import type { Tokens } from '../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    size: tokens.icon.defaultSize,
  } as const
}
